import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { FaPhone } from "react-icons/fa";
import {  FaStar } from "react-icons/fa";
type MenuType =
  | "popularne"
  | "oczyszczanie-terenu"
  | "prace-ziemne"
  | "zakladanie-ogrodow"
  | null;

const HeaderTwo: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<MenuType>(null);
  const [delayedMenu, setDelayedMenu] = useState<MenuType>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeMobileSubmenu, setActiveMobileSubmenu] =
    useState<MenuType>(null);

  useEffect(() => {
    if (activeMenu) {
      setDelayedMenu(activeMenu);
    } else {
      const timer = setTimeout(() => setDelayedMenu(null), 200);
      return () => clearTimeout(timer);
    }
  }, [activeMenu]);

  const handleMouseEnter = (menu: MenuType) => {
    setActiveMenu(menu);
  };

  const handleMouseLeave = () => {
    setActiveMenu(null);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileSubmenu = (menu: MenuType) => {
    setActiveMobileSubmenu(activeMobileSubmenu === menu ? null : menu);
  };

  return (
    <>
      {/* Desktop Header */}
      <header className="hidden lg:flex flex-col absolute z-[9999] w-full">
        <div className="w-full h-full backdrop-blur-md absolute z-10"></div>
        
        <div className="w-full bg-yellow flex flex-row items-center justify-between px-6 xl:px-12 py-2 text-sm xl:text-lg z-20">
          <div className="flex flex-row items-center justify-start gap-4">
            <a
              href="tel:+48604351852"
              className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-start"
            >
              <FaPhoneAlt />
              <span>+48 604 351 852</span>
            </a>
            <a
              href="mailto:kontakt@drzewus.pl"
              className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-start"
            >
              <IoMail />
              <span>kontakt@drzewus.pl</span>
            </a>
          </div>
        </div>

        <div className="w-full flex flex-row items-center justify-between px-4 xl:px-12 py-2 border-b border-b-white z-20">
          <a href="/" className="shrink-0 mr-4">
            <img
              className="h-10 xl:h-16"
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"

            />
          </a>
          <nav className="relative flex flex-row items-center justify-end gap-3 min-[1400px]:gap-6 text-[13px] min-[1400px]:text-base">
            <div
              onMouseEnter={() => handleMouseEnter("popularne")}
              onMouseLeave={handleMouseLeave}
              className="relative"
            >
              <a
                href="#"
                className="text-white hover:opacity-50 transition duration-300 ease-linear font-bold animate-pulse whitespace-nowrap flex items-center gap-1"
              >
                <FaStar /> Popularne
              </a>
              {delayedMenu === "popularne" && (
                <div className="absolute top-full mt-2 shadow-xl bg-white p-6 rounded-xl text-left flex flex-col items-start justify-start gap-2 min-w-[275px] z-[9999]">
                  <a
                    href="/prace-ziemne/czyszczenie-dzialek"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Czyszczenie działek
                  </a>
                  <a
                    href="/oczyszczanie-terenu/mulczer-lesny"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Mulczowanie działek
                  </a>
                  <a
                    href="/prace-ziemne/czyszczenie-dzialek"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Oczyszczanie działek
                  </a>
                  <a
                    href="/oczyszczanie-terenu/karczowanie-drzew"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Karczowanie
                  </a>
                  <a
                    href="/oczyszczanie-terenu/wycinka-klasyczna"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Wycinka drzew
                  </a>
                  <a
                    href="/zakladanie-ogrodu/"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Zakładanie ogrodów
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-rolki"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Trawnik z rolki
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-siewu"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Siew trawy
                  </a>
                  <a
                    href="/oczyszczanie-terenu/karczowanie-drzew"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Usuwanie korzeni
                  </a>
                  <a
                    href="/oczyszczanie-terenu/frezowanie-pni"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Frezowanie pni
                  </a>
                </div>
              )}
            </div>

            <div
              onMouseEnter={() => handleMouseEnter("oczyszczanie-terenu")}
              onMouseLeave={handleMouseLeave}
              className="relative"
            >
              <a
                href="#"
                className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
              >
                Czyszczenie terenu
              </a>
              {delayedMenu === "oczyszczanie-terenu" && (
                <div className="absolute top-full mt-2 shadow-xl bg-white p-6 rounded-xl text-left flex flex-col items-start justify-start gap-2 min-w-[275px] z-[9999]">
                  <a
                    href="/oczyszczanie-terenu/mulczer-lesny"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Mulczowanie działki pomorskie
                  </a>
                  <a
                    href="/oczyszczanie-terenu/wycinka-klasyczna"
                    className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Wycinka drzew - klasyczna
                  </a>
                  <a
                    href="/oczyszczanie-terenu/wycinka-alpinistyczna"
                    className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Wycinka drzew - alpinistyczna
                  </a>
                  <a
                    href="/oczyszczanie-terenu/karczowanie-drzew"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Karczowanie drzew
                  </a>
                  <a
                    href="/oczyszczanie-terenu/frezowanie-pni"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Frezowanie pni
                  </a>
                  <a
                    href="/oczyszczanie-terenu/prace-ziemne"
                    className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Prace ziemne
                  </a>
                  <a
                    href="/oczyszczanie-terenu/niewelacja-terenu"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Niwelacja terenu
                  </a>
                  <a
                    href="/oczyszczanie-terenu/przygotowanie-dokumentacji"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Przygotowanie dokumentacji
                  </a>
                  <a
                    href="/oczyszczanie-terenu/ekspertyzy"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Ekspertyzy
                  </a>
                </div>
              )}
            </div>
            
            <div
              onMouseEnter={() => handleMouseEnter("prace-ziemne")}
              onMouseLeave={handleMouseLeave}
              className="relative"
            >
              <a
                href="#"
                className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
              >
                Prace ziemne
              </a>
              {delayedMenu === "prace-ziemne" && (
                <div className="absolute top-full mt-2 shadow-xl bg-white p-6 rounded-xl text-left flex flex-col items-start justify-start gap-2 min-w-[275px] z-[9999]">
                  <a
                    href="/prace-ziemne"
                    className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Prace ziemne
                  </a>
                  <a
                    href="/prace-ziemne/rownanie-terenu"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Równanie terenu
                  </a>
                  <a
                    href="/prace-ziemne/czyszczenie-dzialek"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Czyszczenie działki
                  </a>
                  <a
                    href="/prace-ziemne/wycinka-drzew"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Wycinka drzew
                  </a>
                </div>
              )}
            </div>

            <div
              onMouseEnter={() => handleMouseEnter("zakladanie-ogrodow")}
              onMouseLeave={handleMouseLeave}
              className="relative"
            >
              <a
                href="#"
                className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
              >
                Zakładanie ogrodów
              </a>
              {delayedMenu === "zakladanie-ogrodow" && (
                <div className="absolute top-full mt-2 shadow-xl bg-white p-6 rounded-xl text-left flex flex-col items-start justify-start gap-2 min-w-[275px] z-[9999]">
                  <a
                    href="/zakladanie-ogrodu/projektowanie"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Projektowanie ogrodu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/"
                    className="block color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Zakładanie ogrodu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/niwelacja-terenu"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Niwelacja terenu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/prace-ziemne"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Prace ziemne
                  </a>
                  <a
                    href="/zakladanie-ogrodu/nawodnienie"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Nawodnienie
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-rolki"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Trawnik z rolki
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-siewu"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Trawnik z siewu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/usluga-glebogryzarki"
                    className="color-green hover:opacity-50 transition duration-300 ease-linear"
                  >
                    Usługa glebogryzarki
                  </a>
                </div>
              )}
            </div>

            <a
              href="/ogrodzenia"
              className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
            >
              Ogrodzenia
            </a>
            <a
              href="/o-nas"
              className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
            >
              O nas
            </a>
             <a
              href="/faq"
              className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
            >
             FAQ
            </a>
             <a
              href="/baza-wiedzy"
              className="text-white hover:opacity-50 transition duration-300 ease-linear whitespace-nowrap"
            >
             Baza wiedzy
            </a>
            <a href="/kontakt">
              {/* Zmniejszony lekko padding dla mniejszych ekranów */}
              <button className="button-green px-4 py-2 xl:px-6 xl:py-3 whitespace-nowrap">Bezpłatna wycena</button>
            </a>
          </nav>
        </div>
      </header>

      {/* Mobile Header */}
      <header className="h-[7vh] lg:hidden flex flex-col justify-center items-center fixed z-[9999] w-full py-2 px-6 bg-yellow">
        <div className="flex w-full justify-between flex-row items-center">
        <a href="/">
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
            alt="Logo Drzewus"
            className="h-10"
          />
        </a>
         <div className="flex gap-4">    
           <a
              href="tel:+48604351852"
              className=" flex items-center gap-1 text-white text-[14px] hover:opacity-50 transition"
            >
              <FaPhoneAlt  className="text-[13px]" />
              604 351 852
            </a>
        <button onClick={toggleMobileMenu} className="text-white text-4xl">
          {isMobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
        </div> 
        </div>
      </header>

      <div className="h-[7vh] block lg:hidden"></div>

      {/* Mobile Menu Content */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed top-[7vh] left-0 w-full bg-white z-[9998] shadow-lg text-left h-[93vh] overflow-y-auto">
          <nav className="flex flex-col p-4 pb-20">
            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleMobileSubmenu("popularne")}
                className="w-full text-left py-2 text-lg font-bold text-gray-800 animate-pulse flex items-center gap-1"
              >
                <FaStar /> Popularne
              </button>
              {activeMobileSubmenu === "popularne" && (
                <div className="pl-4 pb-2 flex flex-col gap-2">
                  <a
                    href="/prace-ziemne/czyszczenie-dzialek"
                    className="color-green hover:opacity-50"
                  >
                    Czyszczenie działek
                  </a>
                  <a
                    href="/oczyszczanie-terenu/mulczer-lesny"
                    className="color-green hover:opacity-50"
                  >
                    Mulczowanie działek
                  </a>
                  <a
                    href="/prace-ziemne/czyszczenie-dzialek"
                    className="color-green hover:opacity-50"
                  >
                    Oczyszczanie działek
                  </a>
                  <a
                    href="/oczyszczanie-terenu/karczowanie-drzew"
                    className="color-green hover:opacity-50"
                  >
                    Karczowanie
                  </a>
                  <a
                    href="/oczyszczanie-terenu/wycinka-klasyczna"
                    className="color-green hover:opacity-50"
                  >
                    Wycinka drzew
                  </a>
                  <a
                    href="/zakladanie-ogrodu/"
                    className="color-green hover:opacity-50"
                  >
                    Zakładanie ogrodów
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-rolki"
                    className="color-green hover:opacity-50"
                  >
                    Trawnik z rolki
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-siewu"
                    className="color-green hover:opacity-50"
                  >
                    Siew trawy
                  </a>
                  <a
                    href="/oczyszczanie-terenu/karczowanie-drzew"
                    className="color-green hover:opacity-50"
                  >
                    Usuwanie korzeni
                  </a>
                  <a
                    href="/oczyszczanie-terenu/frezowanie-pni"
                    className="color-green hover:opacity-50"
                  >
                    Frezowanie pni
                  </a>
                </div>
              )}
            </div>

            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleMobileSubmenu("oczyszczanie-terenu")}
                className="w-full text-left py-2 text-lg font-semibold text-gray-800"
              >
                Czyszczenie terenu
              </button>
              {activeMobileSubmenu === "oczyszczanie-terenu" && (
                <div className="pl-4 pb-2 flex flex-col gap-2">
                  <a
                    href="/oczyszczanie-terenu/mulczer-lesny"
                    className="color-green hover:opacity-50"
                  >
                    Mulczowanie działki pomorskie
                  </a>
                  <a
                    href="/oczyszczanie-terenu/wycinka-klasyczna"
                    className="color-green hover:opacity-50"
                  >
                    Wycinka drzew - klasyczna
                  </a>
                  <a
                    href="/oczyszczanie-terenu/wycinka-alpinistyczna"
                    className="color-green hover:opacity-50"
                  >
                    Wycinka drzew - alpinistyczna
                  </a>
                  <a
                    href="/oczyszczanie-terenu/karczowanie-drzew"
                    className="color-green hover:opacity-50"
                  >
                    Karczowanie drzew
                  </a>
                  <a
                    href="/oczyszczanie-terenu/frezowanie-pni"
                    className="color-green hover:opacity-50"
                  >
                    Frezowanie pni
                  </a>
                  <a
                    href="/oczyszczanie-terenu/prace-ziemne"
                    className="color-green hover:opacity-50"
                  >
                    Prace ziemne
                  </a>
                  <a
                    href="/oczyszczanie-terenu/niewelacja-terenu"
                    className="color-green hover:opacity-50"
                  >
                    Niwelacja terenu
                  </a>
                  <a
                    href="/oczyszczanie-terenu/przygotowanie-dokumentacji"
                    className="color-green hover:opacity-50"
                  >
                    Przygotowanie dokumentacji
                  </a>
                  <a
                    href="/oczyszczanie-terenu/ekspertyzy"
                    className="color-green hover:opacity-50"
                  >
                    Ekspertyzy
                  </a>
                </div>
              )}
            </div>

            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleMobileSubmenu("prace-ziemne")}
                className="w-full text-left py-2 text-lg font-semibold text-gray-800"
              >
                Prace ziemne
              </button>
              {activeMobileSubmenu === "prace-ziemne" && (
                <div className="pl-4 pb-2 flex flex-col gap-2">
                  <a
                    href="/prace-ziemne"
                    className="color-green hover:opacity-50"
                  >
                    Prace ziemne
                  </a>
                  <a
                    href="/prace-ziemne/rownanie-terenu"
                    className="color-green hover:opacity-50"
                  >
                    Równanie terenu
                  </a>
                  <a
                    href="/prace-ziemne/czyszczenie-dzialek"
                    className="color-green hover:opacity-50"
                  >
                    Czyszczenie działki
                  </a>
                  <a
                    href="/prace-ziemne/wycinka-drzew"
                    className="color-green hover:opacity-50"
                  >
                    Wycinka drzew
                  </a>
                </div>
              )}
            </div>

            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleMobileSubmenu("zakladanie-ogrodow")}
                className="w-full text-left py-2 text-lg font-semibold text-gray-800"
              >
                Zakładanie ogrodów
              </button>
              {activeMobileSubmenu === "zakladanie-ogrodow" && (
                <div className="pl-4 pb-2 flex flex-col gap-2">
                  <a
                    href="/zakladanie-ogrodu/projektowanie"
                    className="color-green hover:opacity-50"
                  >
                   Projektowanie ogrodu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/"
                    className="color-green hover:opacity-50"
                  >
                    Zakładanie ogrodu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/niwelacja-terenu"
                    className="color-green hover:opacity-50"
                  >
                    Niwelacja terenu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/prace-ziemne"
                    className="color-green hover:opacity-50"
                  >
                    Prace ziemne
                  </a>
                  <a
                    href="/zakladanie-ogrodu/nawodnienie"
                    className="color-green hover:opacity-50"
                  >
                    Nawodnienie
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-rolki"
                    className="color-green hover:opacity-50"
                  >
                    Trawnik z rolki
                  </a>
                  <a
                    href="/zakladanie-ogrodu/trawa-z-siewu"
                    className="color-green hover:opacity-50"
                  >
                    Trawnik z siewu
                  </a>
                  <a
                    href="/zakladanie-ogrodu/usluga-glebogryzarki"
                    className="color-green hover:opacity-50"
                  >
                    Usługa glebogryzarki
                  </a>
                </div>
              )}
            </div>

            <a
              href="/ogrodzenia"
              className="py-2 text-lg font-semibold text-gray-800 border-b border-gray-200"
            >
              Ogrodzenia
            </a>
            <a
              href="/o-nas"
              className="py-2 text-lg font-semibold text-gray-800"
            >
              O nas
            </a>
             <a
              href="/faq"
              className="py-2 text-lg font-semibold text-gray-800"
            >
              FAQ
            </a>
            <a
              href="/baza-wiedzy"
              className="py-2 text-lg font-semibold text-gray-800"
            >
              Baza wiedzy
            </a>
            <a href="/kontakt" className="py-2">
              <button className="button-green w-full text-center">
                Bezpłatna wycena
              </button>
            </a>
          </nav>
        </div>
      )}
      
      {/* Social Sticky */}
      <div className="fixed right-0 top-[40vh] flex flex-col bg-white shadow-xl rounded-l-xl z-[999999] gap-2 p-2 border border-l-green-800 border-y-green-800">
        <a
          href="https://www.facebook.com/drzewuspomorskie"
          className="text-2xl text-green hover:opacity-50 transition duration-300 ease-linear cursor-pointer"
          target="_blank"
        >
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/fb-logo.png"
            alt="Facebook - Drzewus Pomorskie"
            className="w-8 lg:w-12 "
          />
        </a>
        <a
          href="https://www.youtube.com/@drzewusmistrzterenu"
          className="text-2xl text-green hover:opacity-50 transition duration-300 ease-linear cursor-pointer"
          target="_blank"
        >
          <img
            src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/youtube-icon-free-vector.jpg"
            alt="YouTube - kanał Drzewus Mistrz Terenu"
              className="w-8 lg:w-12 "
          />
        </a>
      </div>
    </>
  );
};

export default HeaderTwo;